import React from 'react';
import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';

const priorityLabels = {
    NORMAL: 'Normal',
    URGENT: 'Urgente',
    EMERGENCY: 'Emergencial',
};

const statusLabels = {
    OPEN: 'Aberta',
    IN_PROGRESS: 'Em Andamento',
    COMPLETED: 'Concluída',
};

const zoneLabels = {
    URBAN: 'Urbana',
    RURAL: 'Rural',
};

/* Ocorrências emergenciais recebem destaque, assim como as atrasadas das ocorrências comuns */
const isEmergency = (serviceOrder) => serviceOrder.priority === 'EMERGENCY';

const statusClass = (status) => {
    if (status === 'IN_PROGRESS') return 'analise';
    if (status === 'COMPLETED') return 'resolvido';
    return 'novo';
}

export default function InfoServiceOrder({ serviceOrders }) {

    const navigate = useNavigate();

    return (
        <div>
            <div id='allcomplaints' className="list-ocorrencias">
                <ul>
                    {serviceOrders.map(serviceOrder => (
                        <li key={serviceOrder.id} className={isEmergency(serviceOrder) ? "container-red" : "container-blue"}>
                            <strong>Nº DA ORDEM:
                                <span>{serviceOrder.orderNumber}</span>
                            </strong>

                            <strong>BAIRRO:
                                <span>{serviceOrder.location?.neighborhood}</span>
                            </strong>

                            <strong>ZONA:
                                <span>{zoneLabels[serviceOrder.location?.zone]}</span>
                            </strong>

                            <strong>EMISSÃO:
                                <span>
                                    {serviceOrder.issuedAt ? (
                                        <Moment locale format={'DD/MM/YYYY'}>
                                            {serviceOrder.issuedAt}
                                        </Moment>
                                    ) : 'Sem data'}
                                </span>
                            </strong>

                            <strong>PRIORIDADE:
                                <span>{priorityLabels[serviceOrder.priority]}</span>
                            </strong>

                            <strong>STATUS:
                                <span className={statusClass(serviceOrder.status)}>
                                    {statusLabels[serviceOrder.status]}
                                </span>
                            </strong>

                            <strong>RESPONSÁVEL:
                                <span>{serviceOrder.engineer?.name || 'Sem responsável'}</span>
                            </strong>

                            <strong>CRIADA POR:
                                <span>{serviceOrder.userName || 'Não informado'}</span>
                            </strong>

                            <div
                                className="button-info-complaint"
                                onClick={() => navigate(`/service-order/${serviceOrder.id}`, {
                                    state: {
                                        canManage: true,
                                        from: [
                                            { name: 'Ocorrências Internas', href: '/manage-service-orders' },
                                            { name: 'Gerenciar Ocorrências', href: '/manage-service-orders' },
                                        ]
                                    }
                                })}
                            >
                                Ver Detalhes
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
